import CreateAccount from "./create-account.builder";
import createAccountBuilderConfig from "./create-account.builder.config"

export default {
  config: createAccountBuilderConfig,
  component: CreateAccount,
};
